module.exports = __webpack_public_path__ + "static/media/johnny-cohen-OxOxqLAWvE0-unsplash.7f59b3c7.jpg";